'use client';
import * as React from 'react';

var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgLelandPlusIcon = function SvgLelandPlusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#leland-plus-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 0h48.188v48.188H0z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#leland-plus-icon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#leland-plus-icon_svg__c)",
    fillRule: "evenodd",
    d: "m35.213 12.633-16.941 5.082-5.647 17.506 17.506-5.083zM23.92 26.749a2.823 2.823 0 1 0 0-5.647 2.823 2.823 0 0 0 0 5.647",
    clipRule: "evenodd"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "leland-plus-icon_svg__c",
    x1: 23.5,
    x2: 25.5,
    y1: 18,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1BB63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#F2E4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEA351"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "leland-plus-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "leland-plus-icon_svg__b",
    width: 22.59,
    height: 22.586,
    x: 12.625,
    y: 12.633,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.651
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4165_7788"
  })))));
};

export { SvgLelandPlusIcon as default };
//# sourceMappingURL=leland-plus-icon.svg.js.map
